import React from 'react';

import { Text } from '@change/ds-core-ui/Text';
import { TextArea, TextField } from '@change/ds-forms';

export const IssuePersonalStoryField: React.FC<Props> = ({
	name,
	title,
	subtitle,
	label,
	placeholder,
	onBlur,
	textAreaClassName = 'bg-background-base',
}) => {
	return (
		<div className="flex w-full flex-col gap-4">
			<div>
				<Text as="h2" fontWeight="bold" variant="heading" size="x-small">
					{title}
				</Text>
				<Text as="p" size="small" className="text-typography-weak">
					{subtitle}
				</Text>
			</div>

			<TextField
				name={name}
				data-qa={`${name}-input`}
				label={label}
				size="large"
				labelIsVisible={false}
				maxLength={500}
				placeholder={placeholder}
				onBlur={onBlur}
				input={<TextArea className={textAreaClassName} />}
			/>
		</div>
	);
};

type Props = {
	name: string;
	title: string;
	subtitle: string;
	label: string;
	placeholder?: string;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	textAreaClassName?: string;
};
